module.exports = __webpack_public_path__ + "img/icon_take_effectt.e584426a.png";